import { type FC, useMemo } from 'react';
import { Layer, Source } from 'react-map-gl';
import { quiverPlotLayer } from '../constants/layers-config';
import { getQuiverPlotFeatures } from '../utils/layer-utils';
import { layerSources } from '../constants/constants';
import { type TidalVector } from '../types';

interface Props {
  vectors: TidalVector[];
}

const QuiverPlotLayer: FC<Props> = ({ vectors }) => {
  const data = useMemo(() => {
    const features = getQuiverPlotFeatures(vectors);

    return {
      type: 'FeatureCollection',
      features,
    };
  }, [vectors]);

  return (
    <Source id={layerSources.quiverPlot} type="geojson" data={data}>
      <Layer {...quiverPlotLayer} />
    </Source>
  );
};

export default QuiverPlotLayer;
